import Loading from './Loading.class.js'

export default class PageLoading extends Loading {
  showLoading() {
    super.showLoading({ title: this.$t('LOADING_PAGE_TITLE') })
  }
}
